<template>
  <section id="selectedProductSection" class="">
    <sectionHeader :data="headerData">
      <svg
            id="articleSvg"

        version="1.1"
        width="60"
        height="80"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 595.3 841.9"
        style="enable-background: new 0 0 595.3 841.9"
        xml:space="preserve"
      >
        <path
          d="M420.1,459c0,0.1,0.1,0.2,0.3,0.4c0.1,0.1,0.1,0.1,0.1,0.1c2.2,1.5,3.9,3.6,5.7,5.5c0.5,0.6,0.8,1.4,1.2,2.2
	c1.1,2,2.1,4.1,2.8,6.4c0.2,0.8,0.4,1.6,0.7,2.4c0.9,3.7,1.1,7.5,0.8,11.4c-0.1,1.2-0.4,2.4-0.7,3.6c-0.7,3.3-1.3,6.7-1.7,10.1
	c-0.3,2.2-1.2,4.2-2.2,6.2c-0.6,1-1.2,2-1.8,3c-0.4,0.6-0.7,1.2-1,1.9c-1.2,3-1.9,6.2-2.2,9.4c-0.5,5.5-0.5,11-0.7,16.5
	c0,0.9,0,1.8,0,2.7c-0.1,1.3,0.3,2.4,1.3,3.3c1.6,1.6,2.6,3.5,3.3,5.7c0.2,0.6,0.4,1.2,0.4,1.9c0.2,2.5,0.3,5,0.4,7.6
	c0.2,3.1,0.4,6.2,0.6,9.3c0,0.5,0.1,0.9,0.1,1.4c0.3,7.4,0.7,14.9,1,22.3c0.2,3.3,0.3,6.6,0.5,9.9c0.2,3.7,0.5,7.4,0.8,11
	c0.2,2.4,0.3,4.8,0.4,7.2c0.2,4.5,0.5,8.9,0.7,13.4c0.1,2.6,0.2,5.2,0,7.8c-0.2,1.7,0.1,3.5,0.1,5.2c-0.1,4.8-0.1,9.7-0.3,14.5
	c-0.2,4.5-0.6,9-1,13.5c-0.2,3-0.5,6.1-0.9,9.1c-0.6,5.3-1.2,10.7-2,16c-0.8,5.2-1.8,10.4-3,15.6c-0.5,2.1-1,4.1-1.5,6.2
	c-0.2,0.9-0.3,1.8-0.6,2.7c-0.5,1.9-0.9,3.9-1.5,5.8c-1.3,4.4-2.7,8.8-4,13.2c-0.4,1.2-0.8,2.5-1.4,3.6c-1,2-2,4.1-3.4,5.9
	c-1.7,2.3-3.9,4.2-6.7,5.1c-1.6,0.5-3.2,1.1-4.8,1.5c-2.8,0.6-5.6,1.4-8.6,1.4c-0.8,0-1.5,0.2-2.3,0.3c-1,0.1-1.9,0.2-2.9,0.3
	c-0.2,0-0.4,0-0.6,0c-3.5,0.7-7.1,0.6-10.6,1c-3.9,0.4-7.7,0.8-11.6,1.1c-3.5,0.3-7,0.5-10.4,0.8c-2.9,0.3-5.8,0.4-8.7,0.4
	c-1.2,0-2.3,0.1-3.5,0.2c-1.2,0.1-2.3,0.2-3.5,0.3c-3.1,0.3-6.2,0.2-9.3,0.4c-9.8,0.5-19.7,0.3-29.5,0.4c-2.2,0-4.4,0.1-6.6,0.2
	c-3.8,0.1-7.5,0.1-11.2,0.3c-5.4,0.3-10.9,0.2-16.3,0.1c-1.1,0-2.2,0.1-3.3,0.2c-0.8,0-1.7,0.1-2.5,0.1c-6.8-0.1-13.6-0.1-20.4-0.2
	c-3.4-0.1-6.7-0.2-10.1-0.4c-3.9-0.2-7.7-0.4-11.6-0.8c-4.6-0.4-9.3-0.5-13.9-0.8c-1.9-0.1-3.8-0.6-5.7-0.9c-2.7-0.5-5.3-1-8-1.7
	c-1.5-0.4-3-0.8-4.4-1.4c-2.3-1-4.6-2.1-6.8-3.2c-1.5-0.7-2.9-1.4-4.3-2.3c-2.2-1.4-4.3-3.1-5.3-5.5c-1.2-2.7-2.4-5.4-2.8-8.4
	c-0.2-1.3-0.4-2.6-0.7-3.8c-0.9-4-1.3-8-2.1-12c-0.3-1.6-0.6-3.2-1-4.8c-1-4.9-1.7-9.8-2.3-14.8c-0.3-2.1-0.5-4.2-0.8-6.4
	c-0.1-0.8,0-1.7-0.1-2.5c-0.2-2.2-0.4-4.4-0.6-6.6c-0.2-2-0.3-4-0.5-6c-0.2-2.8-0.6-5.7-0.8-8.5c-0.1-1.3-0.1-2.7-0.1-4.1
	c0-1.4,0.5-2.8,1.3-4c0.7-1.1,1.2-2.4,2-3.5c0.6-0.7,0.6-1.7,0.6-2.6c0-1.4-0.1-2.8-0.2-4.3c-0.4-5.4-0.2-10.9-0.3-16.3
	c0-0.9-0.2-1.6-0.7-2.3c-0.8-1-1.5-2.1-2.2-3.2c-1-1.6-1.6-3.4-1.8-5.3c-0.3-2.7-0.1-5.3,0-7.9c0.1-1.4,0.1-2.8,0.3-4.3
	c0.4-3.8,0.7-7.6,1.3-11.4c0.5-3.2,1.9-6,4.4-8.2c0.9-0.8,1.4-1.8,1.6-3c0.4-3.1,0.8-6.3,1.3-9.4c0.5-3,1.1-6,1.6-9
	c0.3-1.7,0.4-3.5,0.5-5.2c0-0.9-0.2-1.9-0.6-2.8c-0.6-1.6-1.1-3.3-1.2-5.1c-0.1-1-0.1-2.1,0.1-3.1c0.9-4.8,1.8-9.5,2.8-14.3
	c0.6-2.8,1.4-5.5,2-8.3c0-0.2,0.1-0.4,0.2-0.6c1.3-2,2.2-4.3,4.3-5.6c0.6-0.4,1-1,1.2-1.7c0.3-1.2,0.7-2.4,1-3.6
	c0.4-1.8,0.8-3.5,1.1-5.3c0.5-3,0.9-6,1.4-9c0.2-1.5,0.5-3,0.8-4.6c0.1-0.4,0.1-0.9,0.3-1.3c0.4-1.6,0.2-3-0.7-4.5
	c-0.6-1-1-2.1-1.4-3.2c-0.5-1.3-0.9-2.7-0.8-4.2c0.1-4.3,0.2-8.5,0.2-12.8c0-3,0.5-5.9,0.3-8.9c-0.2-3,1-5.7,2.8-8.1
	c0.9-1.2,1.4-2.5,1.4-3.9c0-2.1,0-4.3-0.1-6.4c-0.3-4.9-0.6-9.8-0.9-14.7c0-0.7-0.1-1.4,0.3-2.1c0.3-0.5,0.2-1-0.2-1.4
	c-0.3-0.4-0.7-0.8-1-1.2c-2.4-2.4-4-5.2-4.4-8.7c-0.4-3.6-0.8-7.2-1.1-10.8c-0.3-2.9-0.4-5.8-0.9-8.7c-0.5-2.9-0.1-5.5,1.3-8
	c0.3-0.5,0.5-1,0.8-1.6c0.5-1.1,0.7-2.3,0.6-3.6c-0.2-1.2-0.4-3.1-1.2-6.7c-0.1-0.5-0.3-1.3-0.5-2.3c0-0.2-0.2-1-0.4-2.7
	c-0.2-1.6-0.2-1.8-0.4-2.7c-0.3-1.9-0.4-1.9-0.7-3.6c-0.5-2.8-0.7-4.3-0.8-4.7c0-0.3,0-0.9-0.3-1.6c-0.2-0.5-0.6-1-1.1-1.4
	c-1.7-1.5-3-3.2-4-5.2c-0.4-0.9-0.8-1.8-1-2.7c-0.8-3.9-1.7-7.8-2.4-11.8c-0.5-2.9-1-5.7-1.4-8.6c-0.6-4.5-1.2-9-1.8-13.5
	c-0.7-5.9-1.4-11.8-1.5-17.8c-0.1-3.3-0.3-6.6-0.3-9.9c-0.1-4.1,0.2-8.3,0.6-12.4c0.5-4.3,1.2-8.6,1.9-12.9c0.7-4.2,2-8.1,3.2-12.2
	c1.1-3.7,2.5-7.3,4-10.9c1-2.4,2.1-4.7,3.3-7c0.5-1,1-1.9,1.5-2.9c1.7-3.4,3.8-6.6,5.8-9.9c1.2-2,2.6-3.9,4-5.7
	c1-1.3,1.8-2.8,2.8-4.2c1.8-2.4,3.5-4.8,5.6-7c0.7-0.8,1.4-1.7,2.1-2.6c1.4-1.7,2.9-3.3,4.4-4.9c3.2-3.5,6.4-7.1,9.8-10.5
	c3.7-3.6,7.4-7.3,11.5-10.4c5-3.8,10-7.8,14.9-11.7c2.4-1.9,4.6-4,7-5.9c1.6-1.3,3.3-2.5,5-3.7c0.6-0.5,1.3-0.8,1.9-1.3
	c1-0.8,2-1.4,3.2-1.7c0.2-0.1,0.4-0.1,0.6-0.2c1.3-0.6,2.2-1.3,2.4-3c0.2-1.7,0.7-3.4,1-5.1c0.1-0.3,0-0.6,0-1
	c-0.5-0.1-0.9-0.2-1.3-0.2c-2,0-4-0.6-5.9-1.2c-1-0.3-1.6-1-1.6-2.1c0-0.4-0.1-0.8,0-1.2c0.1-0.3,0.2-0.6,0.4-0.8
	c0.2-0.2,0.4-0.5,1.1-0.9c1-0.5,1.9-0.6,2.6-0.6c-0.1-0.2-0.6-21-0.5-23c0-0.9,0.1-1.8,0.4-2.7c0.4-1,0.2-1.4,0.2-1.7
	c0.1-1.1,0.2-1.7,0.2-2.4c0.1-1.4,0.2-2.5,0.5-3.4c0.6-1.9,2.4-2.9,3.3-3.5c6-3.9,32.6-3.2,41.6-3.2c0,0,23.9,0,39.7,3.2
	c0.9,0.2,1.7,0.5,1.7,0.5c0.1,0.1,0.7,0.3,1.3,0.8c1.2,0.9,1.9,2.1,2.1,2.5c0.6,1.1,0.9,2.3,1,3.7c0,0.7,0,1.4,0.1,2.1
	c0,0.4-0.1,0.8,0.1,1.2c0.8,1.9,0.4,25.6,0.2,28.2c0.2,0,1.1,0.2,1.6,1c0.2,0.3,0.2,0.7,0.2,1c0,1.5-0.3,1.9-1.8,2.5
	c-0.7,0.3-1.3,0.4-2,0.5c-1.5,0.2-2.9,0.5-4.5,0.8c-0.2,2.8-0.2,5.6,1.5,8.2c1,0.2,2,0.4,3,0.7c0.3,0.1,0.6,0.2,0.9,0.4
	c1.4,0.9,2.8,1.7,4,2.7c4.4,3.5,8.7,7,13,10.5c0.9,0.8,1.8,1.7,2.7,2.5c1.2,1.1,1.9,2.4,2.4,3.9c0.7,2.3,1.3,4.6,1.6,7
	c0.1,1.1,0.5,2.1,1.5,2.8c0.5,0.4,0.8,1,1.2,1.5c0.7,0.9,1.4,1.9,2.1,2.8c2.9,3.3,5.8,6.6,8.7,9.9c1.2,1.4,2.3,2.8,3.5,4.2
	c0.7,0.8,1.5,1.4,2.3,2.1c0.7,0.6,1.4,1.4,2.3,1.7c0.8,0.3,1.8,0.1,2.7,0.2c0.9,0.1,1.8,0.4,2.6,0.7c0.2,0.1,0.4,0.2,0.5,0.3
	c0.6,0.7,1.4,1.2,2.1,1.8c0.1,0.1,0.8,0.7,1.3,1.3c3.2,3.5,5,7.9,5,7.9c0.5,1.3,1.2,3,1.6,5.4c0.2,1.4,0.8,2.8,0.9,4.2
	c0.1,0.6,0.2,1.7,0.8,2c0.2,0.1,0.6,0.2,1.2,0.3c0.6,0.1,0.7,0.1,1.2,0.1c1.4,0.1,2.5,0.7,3.3,1.8c0.7,1,1.3,2.1,1.9,3.1
	c3.3,5.8,6.3,11.9,9.2,17.9c3.4,7.3,6.3,14.9,9.1,22.4c2.1,5.6,4,11.3,5.8,17c0.7,2.3,1.3,4.7,1.9,7.1c1,3.9,2,7.9,3,11.8
	c0.6,2.6,1.3,5.1,1.8,7.7c0.5,2.5,0.9,5.1,1.4,7.6c0.3,1.7,0.7,3.4,1,5.1c0.3,2,0.5,4,0.8,5.9c0.2,1.7,0.4,3.5,0.6,5.2
	c0.2,2.1,0.4,4.1,0.7,6.2c0.5,2.9,0.6,5.9,0.8,8.9c0.3,5.1,0.8,10.2,0.8,15.3c0,6,0,12,0,18.1c0,1.8-0.2,3.6-0.3,5.4
	c0,0.3-0.1,0.6-0.1,1c0.1,4-0.6,8-0.7,12c0,1.2-0.2,2.3-0.4,3.5c0,0.2-0.1,0.4-0.1,0.6c-0.3,2.4-0.5,4.9-0.8,7.3
	c-0.2,1.8-0.7,3.7-1,5.5c-0.2,1-0.3,2-0.5,3c-0.3,1.8-0.6,3.7-0.9,5.5c-1.5,7.8-5.5,13.3-13.3,15.8c-2.2,0.7-4.5,0.5-6.7,0.5
	c-0.2,0-0.4-0.1-0.4-0.1c0,0,0,0,0,0c-0.2-0.1-0.8-0.2-0.8-0.2c-0.4-0.1-0.5-0.2-0.8-0.2C420.4,458.9,420.1,458.9,420.1,459z
	 M423.2,386.1c-0.2-5.1-0.3-10.6-0.5-16.1c0-1.2-0.2-2.4-0.3-3.7c-0.3-2.8-0.5-5.5-0.8-8.3c-0.3-2.7-0.5-5.4-0.8-8.1
	c-0.3-3-0.7-6-1.2-9c-0.2-1.8-0.5-3.6-0.8-5.4c-0.2-1.4-0.5-2.8-0.7-4.2c-0.6-3-1-6.1-1.8-9.1c-0.6-2-0.9-4.2-1.4-6.2
	c-0.6-2.3-1.1-4.6-1.8-6.9c-1.1-3.9-2.3-7.8-3.4-11.7c-1-3.5-2.3-6.8-3.6-10.2c-1-2.9-2.1-5.7-3.2-8.5c-0.6-1.5-1.3-2.8-2.5-3.9
	c-0.3-0.3-0.7-0.7-1.1-0.7c-1.4,0-2.7-0.1-4.1,0.1c-1.6,0.3-3.3,0.8-4.9,1.2c-3.5,0.9-7,1.9-10.5,2.8c-1.4,0.3-2.7,0.9-3.9,1.6
	c-3.1,1.6-5.7,3.7-8.4,5.9c-1.1,0.9-2.1,2.1-2.9,3.4c-1.6,2.6-2.5,5.5-2.5,8.7c0,0.7,0,1.4,0,2.1c-0.1,6.2-0.1,12.4-0.2,18.6
	c-0.1,9.6-0.2,19.1-0.3,28.7c0,4.1,0,8.1-0.3,12.2c-0.5,8-0.9,16-1.4,24c-0.1,1.6-0.2,3.2-0.2,4.8c-0.1,3.9-0.2,7.9-0.3,11.8
	c-0.1,4.9-0.2,9.7-0.2,14.6c0,3.3,0.9,6.5,2.4,9.5c1.5,3,3.7,5.4,6.2,7.6c1.7,1.5,3.5,2.8,5.7,3.7c5.7,2.3,11.3,4.6,17.1,6.8
	c3.3,1.2,6.6,2.2,9.9,3.3c0.4,0.1,1.6,0.5,3.2,0.7c1.5,0.2,2.7,0.1,3,0.1c1.3-0.1,2.3-0.4,2.8-0.5c0.1,0,0.6-0.2,1.1-0.4
	c0,0,2.1-0.8,3.9-2.5c2.6-2.5,3.9-5.7,4.5-9.2c0.4-2.4,0.6-4.7,1.2-7c0.1-0.2,0.1-0.5,0.1-0.8c0.3-2.2,0.6-4.3,0.9-6.5
	c0.3-2.5,0.6-5,0.8-7.5c0.2-1.7,0.2-3.5,0.4-5.2c0.1-1.3,0.3-2.6,0.3-3.9c0.1-2.5,0.1-4.9,0.2-7.4
	C423,392.5,423.1,389.5,423.2,386.1z"
        />
      </svg>
    </sectionHeader>
    <slider :products="products" />
    <footerLinker :data="headerData" />
  </section>
</template>
<script>
import slider from "@/components/front/home/selectedProduct/slider.vue";
import sectionHeader from "@/components/front/shared/sectionHeader.vue";
import footerLinker from "@/components/front/shared/footerLink.vue";
export default {
  components: {
    sectionHeader,
    slider,
    footerLinker
  },
  data() {
    return {
      headerData: {
        title: this.$cookie.get("ltrTheme")
          ? "Selected and superior products"
          : "محصــــــولات مــــــنتخب و برتــــــر",
        summary: this.$cookie.get("ltrTheme")
          ? "Production with the best raw materials"
          : "تولیـــــد بـــــا بهتریـــــن مـــــواد اولیـــــه",
        routeTitle: this.$cookie.get("ltrTheme")
          ? "Margarine products"
          : "محصولات مارگارین",
        route: "/products",
        image: 'image'
      }
    };
  },
  props: {
    products: Array
  },
  mounted() {
    this.setStyle();
    window.addEventListener("resize", this.setStyle);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setStyle);
  },
  methods: {
    setStyle() {}
  }
};
</script>
